import React from 'react';
import { motion } from 'framer-motion';

const logos = [
  { name: 'FitPair', url: 'https://fit-pair.com', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783582996/Frame_1686556219_ismhkh.jpg' },
  { name: 'Bookotg', url: 'https://bookotg.com', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1780693784/BOTG_Logo_o9fcqe.png' },
  { name: 'Alpha', url: 'https://alphatcsg.com', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782378834/Remove_Background_17322517_peesjl.png' },
  { name: 'Ceylanthro', url: 'https://ceylanthro.com/', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1780166898/Logo_Square_2x_rmw834.png' },
  { name: 'Maison De Charm', url: 'https://maisondecharm.com', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783584736/New_MDC_Logo_No_Background_udiono.png' },
  { name: 'Roaming Logos', url: 'https://roaminglogos.com/', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1779211733/Remove_Background_e9npzp.png' },
  { name: 'WhiteKnight Global Consultancy', url: 'https://whiteknightgc.com', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783585408/Logo_zkogbb.png' },
  { name: 'Basedbyte', url: 'https://basedbyte.com', img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783585494/Transparent_mns95z.png' }
];

const LogoCloud = () => {
  return (
    <section className="w-full bg-white py-[80px] overflow-hidden select-none relative border-b border-slate-100">
      <style>
        {`
          @keyframes marquee-scroll {
            from { transform: translateX(0); }
            to { transform: translateX(calc(-50% - 30px)); }
          }
          .marquee-content {
            animation: marquee-scroll 15s linear infinite;
            will-change: transform;
          }
          .marquee-container:hover .marquee-content {
            animation-play-state: paused;
          }
        `}
      </style>
      <div className="max-w-[1200px] mx-auto relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center text-xs font-bold tracking-widest text-slate-400 uppercase mb-[60px]"
        >
          TRUSTED BY INNOVATIVE COMPANIES & BRANDS
        </motion.h2>

        <div className="marquee-container relative flex overflow-hidden group [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
          <div className="marquee-content flex shrink-0 gap-[60px] md:gap-[100px] min-w-full items-center">
            {[...logos, ...logos].map((logo, i) => (
              <a
                key={i}
                href={logo.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center shrink-0"
                title={logo.name}
              >
                <img
                  src={logo.img}
                  alt={logo.name}
                  className="h-[48px] md:h-[72px] w-auto grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300 object-contain"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoCloud;